module.exports = __webpack_public_path__ + "img/svg/step1.af31c7caf07028b120945e9b870f1860.svg";